import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import { Logout } from '../pages/Logout';
import { ForgotPassword } from '../pages/ForgotPassword';
import { ResetPassword } from '../pages/ResetPassword';
import { Dashboard } from '../pages/dashboard';
import { Pingstations } from '../pages/Pingstations';
import { Broadcast } from '../pages/Broadcast';
import { Users } from '../pages/Users';
import { PingstationEdit } from '../pages/PingstationEdit';
import { BroadcastEdit } from '../pages/BroadcastEdit';
import { BroadcastCreate } from '../pages/BroadcastCreate';
import { UserEdit } from '../pages/UserEdit';
import { UserCreate } from '../pages/UserCreate';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/pingstations" element={<Pingstations />} />
        <Route path="/pingstation/edit/:id" element={<PingstationEdit />} />
        <Route path="/broadcast" element={<Broadcast />} />
        <Route path="/broadcast/edit/:id" element={<BroadcastEdit />} />
        <Route path="/broadcast/create" element={<BroadcastCreate />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/edit/:id" element={<UserEdit />} />
        <Route path="/user/create" element={<UserCreate />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
